"use client";
import { useEffect, useRef } from "react";
import Hls from "hls.js";

export default function HlsPlayer({ src, autoPlay = true, controls = true }) {
    const videoRef = useRef<HTMLVideoElement>(null);
    const hls = useRef(null);
    let reInit = null as any;


    const start = () => {
        const video = videoRef.current;

        reInit = function initHLS() {
            if (video.canPlayType("application/vnd.apple.mpegurl")) {
                video.src = src;
            } else if (Hls.isSupported()) {

                hls.current = new Hls({
                    enableWorker: true,
                    lowLatencyMode: true,
                    liveSyncDurationCount: 1,
                    liveMaxLatencyDurationCount: 3,
                });

                hls.current.loadSource(src);
                hls.current.attachMedia(video);

                hls.current.on(Hls.Events.ERROR, async (event, data) => {
                    if (data.fatal) {
                        switch (data.type) {
                            case Hls.ErrorTypes.NETWORK_ERROR:
                                await alerter("restart 1")
                                hls.current.startLoad();
                                break;
                            case Hls.ErrorTypes.MEDIA_ERROR:
                                hls.current.recoverMediaError();
                                break;
                            default:
                                if (hls) {
                                    hls.current.destroy();
                                    setTimeout(() => {
                                        initHLS()
                                    }, 1000);
                                }
                                break;
                        }
                    }
                });
            }

        }

        reInit();
    }
    useEffect(() => {
        const video = videoRef.current;
        start();
        return () => {
            if (hls.current) {
                hls.current.destroy();
                hls.current = null;
            }
            if (video) {
                video.pause();
                video.removeAttribute("src");
                video.load();
            }
        };
    }, [src]);

    return (
        <video
            onError={async () => {
                setTimeout(() => {
                    start()
                }, 500);
            }}
            ref={videoRef}
            autoPlay={autoPlay}
            controls={controls}
            // poster={"https://cdn.qepal.com/qepal/turing128.webp"}
            style={{ minHeight: 200, maxHeight: "80vh", width: "auto", background: "black", margin: "3px 0 3px 0" }}
        />
    );
}
